import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../../actions/fillCombo_action';
import { cityActionId, countryActionId, toastError, toastSuccess, manualFormsPricesListActionId, BarActionId, MasterBarActionId, MasterCMFActionId } from "../../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import { getExhibitionDaysList_action, insertUpdateExhibitionDays_action } from "../../../../../actions/admin_module_action/master_action/exhibition_master_action/exh_exhibitionDays_action";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";


class Exh_ExhibitionDays extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            list: [],
            manualFormsList: [],
            ManualFormID: '',
            isOpen: false,
            toAdd: false,
            ExhibitionID: '',
            BarList: [],
            CFMList: [],
        }
    }

    componentDidMount() {
        this.setState({
            ExhibitionID: this.props.location.state != null && this.props.location.state.ExihibitionID != null ? this.props.location.state.ExihibitionID : '',
        }, () => {
            this.getExhibitionDaysList()
        })

    }

    getExhibitionDaysList() {
        this.setState({ isLoading: true })
        this.props.getExhibitionDaysList_action(this.state.ExhibitionID)
            .then((data) => {
                if (data.error != 1) {
                    if (data.data.length > 0) {
                        this.setState({
                            list: data.data.map(item => {
                                return {
                                    ExhibitionDaysID: item.ExhibitionDaysID,
                                    AllocatedDate: item.AllocatedDate != null ? moment(item.AllocatedDate).toDate() : null,
                                    FromTime: moment(item.FromTime, "hh:mm A").format("HH:mm"),
                                    ToTime: moment(item.ToTime, "hh:mm A").format("HH:mm"),
                                    Keyword: item.Keyword,
                                    ActionID: 0,
                                }
                            }),
                            isAdd: false
                        })
                    }
                    else {
                        this.setState({ isAdd: true })
                    }
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    insertUpdateManualFormsMasterList() {
        this.setState({ isLoading: true })
        const { list, ExhibitionID } = this.state
        const array = []
        list.map((data) => {
            if (data.ActionID != 0) {
                array.push({
                    ExhibitionDaysID: data.ExhibitionDaysID,
                    AllocatedDate: data.AllocatedDate != null ? moment(data.AllocatedDate).format('yyyy-MM-DD') : null,
                    FromTime: moment(data.FromTime, "H:mm").format("hh:mm A"),
                    ToTime: moment(data.ToTime, "H:mm").format("hh:mm A"),
                    Keyword: data.Keyword,
                    ActionID: data.ActionID,
                })
            }
        })
        this.props.insertUpdateExhibitionDays_action(ExhibitionID, array)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false })
                    toastSuccess("Exhibition days update successfully")
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    handleInput(e, index, param) {
        const { list } = this.state
        console.log("sagar------->", e)
        list.map((data, i) => {
            if (index == i) {
                if (param == 'AllocatedDate') {
                    data.AllocatedDate = e
                } else if (param == 'FromTime') {
                    data.FromTime = e
                } else if (param == 'ToTime') {
                    data.ToTime = e
                } else if (param == 'Keyword') {
                    data.Keyword = e.target.value
                }
                data.ActionID = 2
            }
        })
        this.setState({ list: list })
    }

    addRow() {
        this.setState(prevState => ({
            list: [
                ...prevState.list,
                {
                    ExhibitionDaysID: null,
                    AllocatedDate: null,
                    FromTime: '',
                    ToTime: '',
                    Keyword: '',
                    ActionID: 1,
                }
            ]
        }))
    }

    deleteRow = (index) => {
        this.setState(prevState => ({
            list: prevState.list.map((item, i) =>
                i === index
                    ? { ...item, ActionID: 3 }
                    : item
            )
        }));
    };


    getWriteAccess() {
        const { loginAccesslist } = this.state
        if (JSON.parse(sessionStorage.getItem('loginDataSS')).UserID == 233) {
            return false
        } else {
            return true
        }
    }

    render() {
        const { isLoading, isOpen, list, manualFormsList, ManualFormID, BarList, CFMList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <AdminDrawer />
                <div className="main-container p-2 mt-2">
                    <div className="main-container p-2">

                        <div class="table-responsive mt-5">
                            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th className="text-center" style={{ width: '10px' }}>Action</th>
                                        <th className="text-center" >Date</th>
                                        <th className="text-center">From Time</th>
                                        <th className="text-center">To Time</th>
                                        <th className="text-center" style={{ width: '300px' }}>Keyword</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        list.length > 0 ? <>{
                                            list.map((data, i) => (
                                                <tr key={i}>
                                                    {data.ActionID != 3 &&
                                                        <>
                                                            <td>
                                                                <button
                                                                    title="Delete FreightForward"
                                                                    class="btn btn-sm padding_0"
                                                                    onClick={() => this.deleteRow(i)}
                                                                >
                                                                    <i class="fa fa-trash action_btn_table"></i>
                                                                </button>
                                                            </td>
                                                            <td>
                                                                <DatePicker className="form-control"
                                                                    dateFormat="dd-MM-yyyy"
                                                                    selected={data.AllocatedDate}
                                                                    onChange={(e) => this.handleInput(e, i, 'AllocatedDate')}
                                                                    peekNextMonth
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    placeholderText="dd-mm-yyyy"
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                {/* <TimePicker
                                                                    className='time-picker'
                                                                    value={data.FromTime}
                                                                    onChange={(e) => this.handleInput(e, i, 'FromTime')}
                                                                    step={60 * 15}
                                                                /> */}
                                                                <TimePicker
                                                                    onChange={(e) => this.handleInput(e, i, 'FromTime')}
                                                                    value={data.FromTime}
                                                                    disableClock={true}
                                                                    clearIcon={null}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <TimePicker
                                                                    onChange={(e) => this.handleInput(e, i, 'ToTime')}
                                                                    value={data.ToTime}
                                                                    disableClock={true}
                                                                    clearIcon={null}
                                                                />
                                                            </td>
                                                            <td>
                                                                <select
                                                                    className="form-control"
                                                                    value={data.Keyword}
                                                                    onChange={(e) => this.handleInput(e, i, 'Keyword')}
                                                                >
                                                                    <option value={'P'}>Pre-Setup</option>
                                                                    <option value={'D'}>Dismental</option>
                                                                </select>
                                                            </td>
                                                        </>
                                                    }

                                                </tr>
                                            ))}
                                        </> :
                                            <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                    }
                                </tbody>
                            </table>
                            <div style={{ textAlign: 'left' }} className="">

                                <button type="button" class="btn btn-aqua rounded-0 mt-3 ms-2"
                                    onClick={(e) => this.addRow(e)}
                                >
                                    Add +
                                </button>
                            </div>
                            <div style={{ textAlign: 'right' }} >

                                <button type="button" class="btn btn-aqua rounded-1 mt-3 ms-2"
                                    onClick={(e) => this.insertUpdateManualFormsMasterList(e)}
                                    disabled={!this.getWriteAccess()}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, getExhibitionDaysList_action, insertUpdateExhibitionDays_action })(Exh_ExhibitionDays));